import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetCartData, updateWording, ClearBuyNow } from '../../../store/actions';

const PaymentRespFailure = () => {
    const dispatch = useDispatch();
    const currentLanguage = useSelector(({ language }) => language.currentLanguage);
    const navbarCategory = useSelector(({ navigation }) => navigation.navbarCategory);
    const wording = useSelector(({ language }) => language.wording);

    useEffect(() => {
        dispatch(updateWording());
    });

    useEffect(() => {
        dispatch(GetCartData(true));
        dispatch(ClearBuyNow(null, true));
    }, [dispatch]);

    return (
        <>
            <section
                style={{
                    backgroundColor: '#7e7e7e',
                    paddingTop: 20,
                    paddingBottom: 20
                }}>
                <div className='container relative clearfix'>
                    {/* <h1 className='uppercase'>{wording.paymentFailurePage.title}</h1> */}
                    <ol className='breadcrumb'>
                        <li>
                            <a href='/'>
                                {currentLanguage === 'TH'
                                    ? navbarCategory[0].categoriesNameTh
                                    : navbarCategory[0].categoriesNameEn}
                            </a>
                        </li>
                        <li className='active'>{wording.paymentFailurePage.title}</li>
                    </ol>
                </div>
            </section>

            <section className='section-wrap-sm'>
                <div className='container'>
                    <div className='row text-center'>
                        <div className='col-md-10 col-md-offset-1'>
                            <div className='icon-warpper'>
                                <img src='/assets/img/sf/payment-failure.png' alt='payment-failure.png' />
                            </div>
                            <h1 className='uppercase'>{wording.paymentFailurePage.bodyMessage}</h1>
                            <p className='white'>
                                {wording.paymentFailurePage.urlMessage1}{' '}
                                <a href='/user/purchase'>{wording.paymentFailurePage.urlMessage2}</a>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default PaymentRespFailure;
